import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Location } from '@angular/common';
import { StorageService } from 'src/app/service/storage.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent {
  isLoggedIn: string;
  constructor(private router: Router,
    private location: Location,
    private storageService: StorageService
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = this.storageService.getItem('isLoggedIn');
  }

  goBack() {
    // let currentUrl = this.router.url; 
    // const indexOfQuestionMark = currentUrl.indexOf('?'); // Find the index of the question mark
    // if (indexOfQuestionMark !== -1) {
    //   currentUrl = currentUrl.slice(0, indexOfQuestionMark); // Slice the URL from the beginning to the question mark
    //   // this.router.navigateByUrl(currentUrl); // Navigate to the modified URL
    // }
    this.location.back();
  }

  goToViewTicket() {
    this.router.navigateByUrl('view-ticket');
  }

}
